import type { IGameRoundsView } from '@hit-game/shared/types';

import { http } from '../lib/http';

/** Một hũ như web thấy: giá trị hiện tại + mốc nổ gần nhất. */
export interface JackpotGameView {
  gid: number;
  name?: string;
  jackpot: number;
  /** ISO — `undefined` nếu chưa ghi nhận lần nổ nào (cold start). */
  lastHitAt?: string;
  lastValue?: number;
}

export interface JackpotView {
  status: 'connecting' | 'connected' | 'disconnected';
  updatedAt: string | null;
  games: JackpotGameView[];
}

export const jackpotService = {
  /** Ảnh chụp hũ 3 game + mốc nổ (đọc lúc mở app; realtime sau đó qua SSE). */
  getState(): Promise<JackpotView> {
    return http.get('/jackpot');
  },

  /**
   * Ván hiện tại của 4 game — nguồn là tài khoản báo hũ (observer ở worker).
   *
   * `_silent`: sảnh hỏi lại mỗi vài giây, một nhịp hỏng không đáng một toast.
   */
  rounds(): Promise<IGameRoundsView> {
    return http.get('/jackpot/rounds', { _silent: true });
  },
};
